import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let SearchCenter = class SearchCenter extends Vue {
    sortList = [
        {
            imgUrl: require('@blade-sxp/search-center/assets/images/union.png'),
            name: this.$t('similarity'),
            code: 'similarity',
        },
        {
            imgUrl: require('@blade-sxp/search-center/assets/images/sort.png'),
            name: this.$t('time'),
            code: 'captureTime',
        },
    ]; // 默认下拉事件
    selectedImg = require('@blade-sxp/search-center/assets/images/union.png');
    // 下拉点击事件
    handleCommand(val) {
        this.selectedImg = val.imgUrl;
        this.$emit('sort', val.code);
    }
    created() { }
};
SearchCenter = __decorate([
    Component({
        name: 'SearchCenter',
        components: {},
        i18n: {
            messages: {
                en: {
                    similarity: 'Sort by similarity from high to low',
                    time: 'Sort by time from near to far',
                },
                zh: {
                    similarity: '按相似度从高到低',
                    time: '按抓拍时间由近到远',
                },
            },
        },
    })
], SearchCenter);
export default SearchCenter;
